"use client";
import Backdrop, { type BackdropProps } from "@/components/common/Backdrop";
import Carousel, {
  type CarouselProps,
  type CarouselSettings,
} from "@/components/common/Carousel";
import s from "./FullscreenCarousel.module.scss";

const defaultSettings: CarouselSettings = {
  pagination: {
    type: "progressbar",
  },
};

export type FullscreenCarouselProps<T> = CarouselProps<T> &
  BackdropProps & {
    initialSlide: number;
  };

export default function FullscreenCarousel<T>(
  props: FullscreenCarouselProps<T>,
) {
  const { open, onClose, items, renderItem, settings, initialSlide } = props;

  const customSettings = { ...defaultSettings, initialSlide, ...settings };

  return (
    <Backdrop open={open} onClose={onClose}>
      <div className={s.wrapper}>
        <Carousel
          items={items}
          renderItem={renderItem}
          settings={customSettings}
          fullScreen
        />
      </div>
    </Backdrop>
  );
}
